export const NOTE_SUB_TYPES = ['important', 'private', 'pir'];
export const NOTE_SUB_IDS = new Set(NOTE_SUB_TYPES);
export const NOTE_GROUP_IDS = new Set(['note', ...NOTE_SUB_TYPES]);

export function toggleFilterType(appliedTypes, id) {
  const next = new Set(appliedTypes);
  if (next.has(id)) {
    next.delete(id);
  } else {
    next.add(id);
    if (id === 'note') {
      NOTE_SUB_IDS.forEach(sub => next.delete(sub));
    } else if (NOTE_SUB_IDS.has(id)) {
      next.delete('note');
    }
  }
  return next;
}

export function isNoteSubActive(appliedTypes) {
  return NOTE_SUB_TYPES.some(s => appliedTypes.has(s));
}
